<div class="white-box p-3 mb-3">
	<button #hiddenPrintBtn style="display: none" ngxPrint [useExistingCss]="true" printSectionId="to-print-content" printTitle="{{ 'g.site_summary_report' | translate }}"></button>
	<button class="btn fa fa-print fa-lg print-btn" (click)="openPrintModal()" *ngIf="totalDevices.length" title="{{'g.print' | translate}}"></button>

	<app-modal #printModal title="{{ 'g.select_period_to_print' | translate }}" [hasCloseButton]="false" [hasConfirmButton]="false">
		<div class="p-3">
			<ng-select
				class="select"
				[items]="periods"
				[addTag]="false"
				[clearable]="false"
				[searchable]="false"
				bindLabel="label"
				bindValue="value"
				(change)="onPeriodChanged($event.value)"
				[placeholder]="'g.durations' | translate"
				[(ngModel)]="period"
			></ng-select>
			<div class="mt-3 text-end">
			<button class="btn btn-primary" (click)="confirmPrint()">Print</button>
			</div>
		</div>
	</app-modal>

	<app-site-summary-battery-report class="print-content" id="to-print-content" [sitePerformanceScores]="data" [devices]="devices" [siteId]="siteId" [siteInfo]="siteInfo" [period]="period"></app-site-summary-battery-report>

	<div class="filter-container m-4">

		<!-- PERIODS FILTERS-->
		<div class="row align-items-end flex-wrap g-4 justify-content-start">
			<div class="col-sm-6 col-md-2 col-lg-2">
				<label class="text-nowrap" for="periodSelect">{{"rt_history.periods" | translate}}</label>
				<ng-select
					class="select filter-select"
					[items]="periods"
					[addTag]="false"
					[clearable]="false"
					[searchable]="false"
					bindLabel="label"
					bindValue="value"
					[placeholder]="'g.durations' | translate"
					[(ngModel)]="selectedPeriod"
				></ng-select>
			</div>

			<!-- voltage filter -->
			<div class="col-sm-6 col-md-2 col-lg-2" *ngIf="batteryVoltagesOptions.length">
				<label class="text-nowrap" for="batteryVoltageSelect">{{"fleet_reports.battery_voltage" | translate}}</label>
				<ng-select
					id="batteryVoltageSelect"
					class="select filter-select"
					[items]="batteryVoltagesOptionsForScores"
					[addTag]="false"
					[clearable]="false"
					[searchable]="false"
					bindLabel="label"
					bindValue="value"
					[placeholder]="'qv.voltage' | translate"
					[(ngModel)]="selectedBatteryVoltageForScores"
				></ng-select>
			</div>

			<!-- capacity filter -->
			<div class="col-sm-6 col-md-2 col-lg-2" *ngIf="batteryCapacitiesOptions.length">
				<label class="text-nowrap" for="batteryCapacitySelect">{{"devices.battery_capacity" | translate}}</label>
				<ng-select
					id="batteryCapacitySelect"
					class="select filter-select"
					[items]="batteryCapacitiesOptionsForScores"
					[addTag]="false"
					[clearable]="false"
					[searchable]="false"
					bindLabel="label"
					bindValue="value"
					[placeholder]="'qv.capacity' | translate"
					[(ngModel)]="selectedBatteryCapacityForScores"
				></ng-select>
			</div>

			<!-- Manufacturer filter -->
			<div class="col-sm-6 col-md-2 col-lg-2" *ngIf="manufacturersOptionsForScores.length">
				<label class="text-nowrap" for="battery_manufacturer">{{"devices.battery_manufacturer" | translate}}</label>
				<ng-select
					class="select filter-select"
					[(ngModel)]="selectedManufacturerForScores"
					[items]="manufacturersOptionsForScores"
					[addTag]="false"
					[clearable]="false"
					[searchable]="false"
					bindLabel="label"
					bindValue="value"
					[placeholder]="'devices.battery_manufacturer' | translate"
				></ng-select>
			</div>

			<!-- Vintage filter -->
			<div class="col-sm-6 col-md-2 col-lg-2">
				<label class="text-nowrap" for="batteryVintageSelect">{{"devices.battery_vintage" | translate}}</label>
				<ng-select
					name="batteryVintageSelect"
					id="batteryVintageSelect"
					class="select filter-select"
					[multiple]="true"
					[items]="vintageOptionsDropdown"
					[addTag]="true"
					[clearable]="false"
					[searchable]="false"
					bindLabel="label"
					bindValue="value"
					[placeholder]="'devices.battery_vintage' | translate"
					[(ngModel)]="selectedBatteryVintageForScores"
					(ngModelChange)="batteryVintageSelectionChanged()"
				>
					<ng-template ng-label-tmp let-item="item" let-clear="clear">
						<span>
							<span class="ng-value-icon left" (click)="clear(item)" aria-hidden="true">×</span>
							<span class="ng-value-label">{{item.label}}</span>
						</span>
					</ng-template>
				</ng-select>
			</div>
		</div>
	</div>
	
	<div>
		<h1 class="h3 m-4">{{'utilization.site_performance_scores' | translate}}</h1>
		<app-performance-score-widget
			*ngIf="dataLoaded"
			[data]="data"
			[devices]="devices"
			[performance]="false"
			[showNoData]="true"
			[userParentFilters]="true"
			[selectedPeriod]="selectedPeriod"
			[selectedBatteryVoltage]="selectedBatteryVoltageForScores"
			[selectedBatteryCapacity]="selectedBatteryCapacityForScores"
			[selectedManufacturer]="selectedManufacturerForScores"
			[selectedBatteryVintage]="selectedBatteryVintageForScores"
			(prepareParentFiltersOptions)="prepareParentFiltersOptions($event, true)"
			[tooltipType]="'site'" 
			[showTooltip]="true"
		></app-performance-score-widget>
	</div>

	<div class="mt-4 pt-4">
		<app-percent-battery-utilization-scores
			*ngIf="dataLoaded"
			[data]="data"
			[devices]="devices"
			[userParentFilters]="true"
			[selectedPeriod]="selectedPeriod"
			[selectedBatteryVoltage]="selectedBatteryVoltageForScores"
			[selectedBatteryCapacity]="selectedBatteryCapacityForScores"
			[selectedManufacturer]="selectedManufacturerForScores"
			[selectedBatteryVintage]="selectedBatteryVintageForScores"
			(prepareParentFiltersOptions)="prepareParentFiltersOptions($event, true)"
		></app-percent-battery-utilization-scores>
	</div>
<div class="white-box p-3 mb-3">
	<div class="row col-xl-12 mb-4">
		<div class="col-xl-4 col-md-4">
			<div class="input-group">
				<div class="input-group-prepend">
					<span class="input-group-text">{{'g.start_date' | translate}}</span>
				</div>
				<input type="text" class="form-control" placeholder="mm/dd/yyyy" name="dp1" (ngModelChange)="changeDate('fromDate', $event)" [(ngModel)]="fromDate" bsDatepicker #d1="bsDatepicker" [bsConfig]="{containerClass: 'theme-dark-blue'}" [maxDate]="toDate" [minDate]="siteInstallationDate">
				<div class="input-group-append pointer" (click)="d1.toggle()">
					<span class="input-group-text"><i class="fa fa-calendar"></i></span>
				</div>
			</div>
		</div>

		<div class="col-xl-4 col-md-4">
			<div class="input-group">
				<div class="input-group-prepend">
					<span class="input-group-text">{{'g.end_date' | translate}}</span>
				</div>
				<input type="text" class="form-control" placeholder="mm/dd/yyyy" name="dp2" (ngModelChange)="changeDate('toDate', $event)" [(ngModel)]="toDate" bsDatepicker #d2="bsDatepicker" [bsConfig]="{containerClass: 'theme-dark-blue'}" [minDate]="fromDate">
				<div class="input-group-append pointer" (click)="d2.toggle()">
					<span class="input-group-text"><i class="fa fa-calendar"></i></span>
				</div>
			</div>
		</div>
	</div>

	<div class="row col-xl-12 mb-4">
		<!-- voltage filter -->
		<div class="col-sm-6 col-md-3 col-lg-3" *ngIf="batteryVoltagesOptions.length">
			<label for="batteryVoltageSelect">{{"fleet_reports.battery_voltage" | translate}}</label>
			<ng-select
				id="batteryVoltageSelect"
				class="select"
				[items]="batteryVoltagesOptions"
				[addTag]="false"
				[clearable]="false"
				[searchable]="false"
				bindLabel="label"
				bindValue="value"
				[placeholder]="'qv.voltage' | translate"
				[(ngModel)]="selectedBatteryVoltage"
			></ng-select>
		</div>

		<!-- capacity filter -->
		<div class="col-sm-6 col-md-3 col-lg-3" *ngIf="batteryCapacitiesOptions.length">
			<label for="batteryCapacitySelect">{{"devices.battery_capacity" | translate}}</label>
			<ng-select
				id="batteryCapacitySelect"
				class="select"
				[items]="batteryCapacitiesOptions"
				[addTag]="false"
				[clearable]="false"
				[searchable]="false"
				bindLabel="label"
				bindValue="value"
				[placeholder]="'qv.capacity' | translate"
				[(ngModel)]="selectedBatteryCapacity"
			></ng-select>
		</div>

		<!-- Manufacturer filter -->
		<div class="col-sm-6 col-md-3 col-lg-3" *ngIf="manufacturersOptions.length">
			<label for="battery_manufacturer">{{"devices.battery_manufacturer" | translate}}</label>
			<ng-select
				class="select"
				[(ngModel)]="selectedManufacturer"
				[items]="manufacturersOptions"
				[addTag]="false"
				[clearable]="false"
				[searchable]="false"
				bindLabel="label"
				bindValue="value"
				[placeholder]="'devices.battery_manufacturer' | translate"
			></ng-select>
		</div>

		<!-- Vintage filter -->
		<div class="col-sm-6 col-md-3 col-lg-3">
			<label for="batteryVintageSelect">{{"devices.battery_vintage" | translate}}</label>
			<ng-select
				name="batteryVintageSelect"
				id="batteryVintageSelect"
				class="select"
				[multiple]="true"
				[items]="vintageOptionsDropdown"
				[addTag]="true"
				[clearable]="false"
				[searchable]="false"
				bindLabel="label"
				bindValue="value"
				[placeholder]="'devices.battery_vintage' | translate"
				[(ngModel)]="selectedBatteryVintage"
				(ngModelChange)="batteryVintageSelectionChanged()"
			>
				<ng-template ng-label-tmp let-item="item" let-clear="clear">
					<span>
						<span class="ng-value-icon left" (click)="clear(item)" aria-hidden="true">×</span>
						<span class="ng-value-label">{{item.label}}</span>
					</span>
				</ng-template>
			</ng-select>
		</div>
	</div>

	<app-daily-battlink-usage-metrics
		[devices]="devices"
		[userParentFilters]="true"
		[fromDate]="fromDate"
		[toDate]="toDate"
		[selectedBatteryVoltage]="selectedBatteryVoltage"
		[selectedBatteryCapacity]="selectedBatteryCapacity"
		[selectedManufacturer]="selectedManufacturer"
		[selectedBatteryVintage]="selectedBatteryVintage"
		(prepareParentFiltersOptions)="prepareParentFiltersOptions($event, false)"
	></app-daily-battlink-usage-metrics>

	<div class="mt-4 pt-4">
		<app-daily-battery-fleet-utilization
			[fromDate]="fromDate"
			[toDate]="toDate"
			[selectedBatteryVoltage]="selectedBatteryVoltage"
			[selectedBatteryCapacity]="selectedBatteryCapacity"
			[selectedManufacturer]="selectedManufacturer"
			[selectedBatteryVintage]="selectedBatteryVintage"
			(prepareParentFiltersOptions)="prepareParentFiltersOptions($event, false)"
		></app-daily-battery-fleet-utilization>
	</div>
	
	<app-daily-ah-battery-fleet-utilization
		[fromDate]="fromDate"
		[toDate]="toDate"
		[selectedBatteryVoltage]="selectedBatteryVoltage"
		[selectedBatteryCapacity]="selectedBatteryCapacity"
		[selectedManufacturer]="selectedManufacturer"
		[selectedBatteryVintage]="selectedBatteryVintage"
		(prepareParentFiltersOptions)="prepareParentFiltersOptions($event, false)"
	></app-daily-ah-battery-fleet-utilization>
</div>
</div>